import {FAILURE, REQUEST, SUCCESS} from './constants';

export const getRequestActionType = type => `${type}${REQUEST}`;
export const getSuccessActionType = type => `${type}${SUCCESS}`;
export const getFailureActionType = type => `${type}${FAILURE}`;
